import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/sacraments/baptisms', labelKey: 'nav.baptisms' as const },
  { to: '/sacraments/confirmations', labelKey: 'nav.confirmations' as const },
  { to: '/sacraments/marriages', labelKey: 'nav.marriages' as const },
  { to: '/sacraments/funerals', labelKey: 'nav.funerals' as const },
  { to: '/sacraments/transfers', labelKey: 'nav.transfers' as const },
];

export const SacramentsSubnav = () => {
  const { t } = useTranslation('sacraments');

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
